/* eslint-disable no-unused-vars */
import React from 'react';
import at from 'lodash/at';
import styled, { withTheme } from 'styled-components';
import { getCSSVariables } from '../../../cruxComponents/utils';

const Level1Wrapper = styled.div`
  background: rgba(226, 226, 226, 1);
  margin: 0 -100px;
  margin-bottom: 30px;

  ${({ margin, padding })=>
  `
    margin:${margin?.[0]?.['reflexiveCard-level1Wrapper'] || margin?.[1]?.['reflexiveCard-level1Wrapper']};
    padding:${padding?.[0]?.['reflexiveCard-level1Wrapper'] || padding?.[1]?.['reflexiveCard-level1Wrapper']};
  `}
`;

const ReflexiveQuestion = styled.div`
  background: rgba(255, 255, 255, 1);
  border-radius: ${({ themeConfiguration }) =>
    themeConfiguration ?.borderRadius ? themeConfiguration ?.borderRadius : '8px'};
  ${({ view }) =>
    view === 'compact'
      ? `
    @media (min-width: 1280px) {
      padding: 15px 220px;
    }`
      : `
    @media (min-width: 1280px) {
      padding: 15px 120px;
    }`};
  @media (max-width: 1280px) {
    padding: 15px 120px;
  }
  @media (max-width: 1024px) {
    padding: 15px 80px;
  }
  @media (max-width: 768px) {
    padding: 30px;
  }
  @media (max-width: 420px) {
    padding: 25px;
  }
`;

const Level2Wrapper = styled.div`
  border-top: 1px solid #999999;
  padding-left: 20px;
  padding-top: 20px;
  margin-left: -80px;
  padding-left: 80px;
  @media only screen and (max-width: 1025px) {
    margin: 0 -15px;
    padding: 0 15px;
  }
  @media only screen and (max-width: 767px) {
    margin: 0 -10px;
    padding-left: 10px;
  }
`;

const CloseAction = styled.div`
  @media only screen and (min-width: 768px) {
    position: absolute;
    right: 40px;
    width: 40px;
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
`;

function ReflexiveCard({ children, reflexLevel, view, hideWrapper, theme, parentQuestionId }) {
  const {
    pageId,
    config: {
      theme: {
        components: {
          card: { themeConfiguration },
        },
      },
    },
  } = theme;
  
  // CSS Variables
  const cssVariables = getCSSVariables(theme);
  const margin = at(cssVariables, ['pageOverride.margin', 'global.margin']);
  const padding = at(cssVariables, ['pageOverride.padding', 'global.padding']);

  if (hideWrapper) {
    return <>{children}</>;
  }
  if (reflexLevel === 1) {
    if (hideWrapper) return <>{ children }</>
    return (
      <Level1Wrapper id={ `reflexive-card-container-${parentQuestionId}-${reflexLevel}` } name={ `reflexive-card-wrapper-${reflexLevel}` } padding={ padding } margin = { margin }>
        <ReflexiveQuestion view={ view } themeConfiguration={ themeConfiguration }>
          {children}
        </ReflexiveQuestion>
      </Level1Wrapper>
    );
  }
  if (reflexLevel === 2) {
    return(
      <Level2Wrapper id={ `reflexive-card-container-${parentQuestionId}-${reflexLevel}` } data-name={ `reflex-wrapper-${reflexLevel}` }>
        {children}
      </Level2Wrapper>
    );
  }
  return children;
}

export default withTheme(ReflexiveCard);
